export const ZoneActions = {
  CLEAR_STATE: 'clearZoneState',
  EDIT: 'editZone',
  GENERATE_ID: 'generateZoneId',
  SAVE: 'saveZone',
  SET_PROPERTIES: 'setZoneProperties'
};
